import Admin, { Role, hasRole } from '@/models/Admin'
import Qualification from '@/models/Qualification'

export default class QualificationPolicy {
	viewAny(admin: Admin) {
		return true
	}

	view(admin: Admin, qualification: Qualification) {
		return true
	}

	create(admin: Admin) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	update(admin: Admin, qualification: Qualification) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	restore(admin: Admin, qualification: Qualification) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	delete(admin: Admin, qualification: Qualification) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	forceDelete(admin: Admin, qualification: Qualification) {
		return hasRole(admin, Role.ADMIN)
	}

	trash(admin: Admin) {
		return hasRole(admin, Role.ADMIN)
	}
}
